(function () {
    'use strict';

    angular
        .module('oddQuestionnaireTemplateModule')
        .controller('oddQuestionTypeAttachmentController', Controller);

    Controller.$inject = ['$scope'];

    function Controller($scope) {
        $scope.ctxtCtrl.hintMaxLength = _.find($scope.boxModel.ODDQuestionAttributeValues, { 'Code': 'HintMaxLength' }).ValueText;
    }
})();